import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ScrolltopComponent } from './scroll-top/scroll-top.component';

import { NavheaderComponent } from './nav-header/nav-header.component';
import { NavasideComponent } from './nav-aside/nav-aside.component';
import { FooterComponent } from './footer/footer.component';
import { BodyComponent } from './body/body.component';

import { AppLayoutComponent } from './app-layout.component';

import { JasperoAlertsModule } from '@jaspero/ng-alerts';
import { JasperoConfirmationsModule } from '@systemic/ng-confirmations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SystemicModule } from '@systemic/systemic.module';

@NgModule({
  declarations: [
    AppLayoutComponent,
    NavheaderComponent,
    NavasideComponent,
    BodyComponent,
    FooterComponent,
    ScrolltopComponent
  ],
  exports: [
    AppLayoutComponent,
    NavheaderComponent,
    NavasideComponent,
    BodyComponent,
    FooterComponent,
    ScrolltopComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    JasperoAlertsModule,
    JasperoConfirmationsModule,
    SimpleNotificationsModule,
    SystemicModule
  ]
})
export class AppLayoutModule { }



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/app-layout.module.ts